import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

@Injectable()
export class AmplitudeService {
    userId = localStorage.getItem('amplitudeUserEmail');
    isInitialized: boolean =false;

  constructor() {}

  public initializeAmplitude(): void {
    // initialize amplitude with key and user email
    amplitude.init('720abd136a0a7eb9826c0cf8fc285014', this.userId, {
        autocapture:{
          pageViews: true,
          // Set the following to 'false' so that application won't lock up
          networkTracking: true,
          sessions: true,
          formInteractions: true,
          // Set the following to 'false' so that application won't lock up
          elementInteractions: false,
          attribution: true,
          webVitals: true
        }

        // COMMENTING OUT FOR NOW, FOR SOME REASON THESE OPTIONS BREAK THE APPLICATION
        // "fetchRemoteConfig":true,
    });
    const sessionReplayTracking = sessionReplayPlugin({
      sampleRate: undefined
    });
    amplitude.add(sessionReplayTracking);
    this.isInitialized = true;
  }

    public track(eventType: string, eventProperties?: Record<string, any>): void {
    if (!this.isInitialized) {
      const userRole = localStorage.getItem('userRole');
      this.setRole(userRole || 'unknown');
      try{
        this.initializeAmplitude();
        amplitude.track(eventType, eventProperties);
      }catch(e){ console.error('Amplitude service not initialized. Call initialize() first. error:', e);}
      return;
    }
    amplitude.track(eventType, eventProperties);
  }

  public setRole(userRole: string): void {
    const identifyEvent = new amplitude.Identify();
    identifyEvent.set('role', userRole || 'unknown');
    amplitude.identify(identifyEvent);
  }
    // method to send information concerning toast message (message, type, page)
}
